import Check from "./Check";

export default function createEnumCheck(values) {
    return new Check(value => values.includes(value));
}
